import { render } from "./home-skeleton.vue?vue&type=template&id=a23b696a&scoped=true"
import script from "./home-skeleton.vue?vue&type=script&lang=js"
export * from "./home-skeleton.vue?vue&type=script&lang=js"

import "./home-skeleton.vue?vue&type=style&index=0&id=a23b696a&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23b696a"]])

export default __exports__